import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/AppIcon';

const AddRemarkModal = ({
  open,
  record,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation();
  const [remark, setRemark] = useState('');

  useEffect(() => {
    if (!open) return;
    setRemark(record?.remarks && record?.remarks !== '-' ? record.remarks : '');
  }, [open, record?.id]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-xl p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold text-foreground mb-4">{t('Add Remark')}</h3>
        <p className="text-sm text-muted-foreground mb-4">
          {t('Add remark for')} {record?.employee}
        </p>
        <textarea
          value={remark}
          onChange={(e) => setRemark(e?.target?.value)}
          placeholder={t('Enter your remark...')}
          className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent mb-4"
          rows={3}
        />
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm bg-muted hover:bg-muted/80 text-foreground rounded-lg transition-colors"
          >
            {t('Cancel')}
          </button>
          <button
            type="button"
            onClick={() => onSave?.(remark)}
            className="px-4 py-2 text-sm bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors flex items-center gap-2"
          >
            <Icon name="MessageCircle" size={16} />
            <span>{t('Save Remark')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRemarkModal;
